import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedSpotlight() {
  const featured = articles[0];

  return (
    <section className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8" aria-label="今日重磅爆料">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-primary-500 mb-10 md:mb-14">
          「 今日重磅爆料 」
        </h2>

        <div className="text-left">
          {/* Hot badge */}
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-5">
            <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center text-accent-400" />
            热度 9.8
          </div>

          {/* Quote body */}
          <blockquote className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed mb-8">
            "{featured.summary}"
          </blockquote>

          {/* Author info */}
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center text-background-50 text-sm font-bold">
              51
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-800">{featured.author}</p>
              <p className="text-xs text-foreground-500">{featured.date} · 阅读量 {featured.views.toLocaleString()}</p>
            </div>
          </div>

          {/* Action buttons */}
          <div className="flex items-center justify-end gap-2">
            <Link
              to={`/article/${featured.id}`}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-300/60 hover:border-primary-500 hover:text-primary-500 transition-colors"
              aria-label="查看详情"
            >
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}